module.exports = __webpack_public_path__ + "static/media/medical-request-example.3b7f0009.webp";